import {connect} from 'react-redux'
import CompletionStatusData from '../components/completion-status/CompletionStatusData'
import {RootState} from '../../common/redux/store'

const mapStateToProps = (state: RootState) => ({
  completionStatusList: state.dashboard.completionData,
})

export default connect(mapStateToProps)(CompletionStatusData)
